import { render, staticRenderFns } from "./DeletedTeamsList.vue?vue&type=template&id=426d7d62&scoped=true"
import script from "./DeletedTeamsList.vue?vue&type=script&lang=js"
export * from "./DeletedTeamsList.vue?vue&type=script&lang=js"
import style0 from "./DeletedTeamsList.vue?vue&type=style&index=0&id=426d7d62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426d7d62",
  null
  
)

export default component.exports